// The AuthKit React SDK exposes the current access token via a hook context.
// To keep the API clients decoupled from React (so they can be unit-tested
// without rendering), we wrap the SDK behind a module-level getter that
// `<AuthKitProvider>` registers at app boot via `setAccessTokenGetter`.
// Tests register a stub getter (see core/api-clients/*.test.ts).
//
// `forceRefresh` bypasses the SDK's cached access token and triggers a
// refresh round-trip via the refresh token. `apiFetch` uses this on a 401
// response to recover from clock skew / JWKS-cache misses before surfacing
// the error.

export type GetAccessTokenOptions = {
  forceRefresh?: boolean;
};

type Getter = (options?: GetAccessTokenOptions) => Promise<string | null>;

let getter: Getter | null = null;

export function setAccessTokenGetter(fn: Getter): void {
  getter = fn;
}

export async function getAccessToken(
  options?: GetAccessTokenOptions,
): Promise<string | null> {
  if (!getter) throw new Error('Access-token getter not initialised');
  return getter(options);
}

/** Test-only — clears the registered getter so each test starts fresh. */
export function __resetAccessTokenGetterForTests(): void {
  getter = null;
}
